import {useEffect, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {MenuComponent} from '../assets/ts/components'
import {SidebarPerfil} from '../../app/components/Modals/Topbar/SidebarPerfil/SidebarPerfil'
import {ModalText} from '../../app/components/Modals/General/ModalText/ModalText'
import {AlertStatusPluginSpace} from './components/Alert/Alert'
import {InboxCompose} from '../partials/layout/InboxCompose'
import {ButtonChatIA} from './components/ChatIA/ButtonChatIA'
import {DrawerMessenger} from '../partials'
import usePluginsSpace from '../../app/hooks/usePluginSpace'
import {Loading} from '../../app/components/Loading/Loading'

const MasterLayout = () => {
  const [openChatIA, setOpenChatIA] = useState(false)
  const {loadingGlobal} = usePluginsSpace()

  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        {/*   <RightToolbar />*/}

        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />
          <AlertStatusPluginSpace />
          <div id='kt_content' className='d-flex flex-column flex-column-fluid'>
            {/*<Toolbar />*/}
            <div
              className='post d-flex flex-column-fluid'
              id='kt_post'
              style={{
                paddingTop: '32px',
              }}
            >
              {loadingGlobal ? (
                <div className='d-flex justify-content-center w-100 h-100'>
                  <Loading />
                </div>
              ) : (
                <Content>
                  <Outlet />
                </Content>
              )}
            </div>
          </div>
          <Footer />
        </div>
      </div>

      <SidebarPerfil />

      <ButtonChatIA onClick={() => setOpenChatIA(!openChatIA)} />
      <DrawerMessenger open={openChatIA} setOpen={setOpenChatIA} />

      {/*Envio de Email */}
      <InboxCompose
        show={false}
        handleClose={function (): void {
          throw new Error('Function not implemented.')
        }}
      />

      <ModalText />
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
